import { EntityName } from 'record-it-time-common/EntityName';
import { KeyValueStorage, TableConfiguration } from 'record-it-utils/dataStorage/KeyValueStorage';
import { KeyValueStorageStrategy } from 'record-it-utils/dataStorage/KeyValueStorageStrategy/KeyValueStorageStrategy';
export function initKeyValueStorage(strategy: KeyValueStorageStrategy): Promise<void> {
  const entityTableConfigurationsMap = {} as Record<EntityName, TableConfiguration>;
  for (const entityName of Object.values(EntityName)) {
    entityTableConfigurationsMap[entityName] = {};
  }
  return KeyValueStorage.init(strategy, {
    storeName: 'record-it-time',
    tableConfigurationMap: {
      general: {
        default: true
      },
      entityManager: {},
      ...entityTableConfigurationsMap
    }
  });
}